import React from 'react';
import { LFC } from '../../../Legacy';

export const AlertStyleDialog: LFC<{ clickable: boolean, delay: number }> = ({ children }) => {

    return <>
        {children}
    </>;
};
